import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { EmployeeService } from '../employee.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Union, UserType, Gender, Taluk, District, State, RelationType } from '../../agent/agent-interface.service';
import { GlobalValidationService } from 'src/app/global-validation.service';
import { GlobalService } from 'src/app/global.service';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { ThemePalette } from '@angular/material';
@Component({
  selector: 'app-employee-register',
  templateUrl: './employee-register.component.html',
  styleUrls: ['./employee-register.component.scss']
})
export class EmployeeRegisterComponent implements OnInit {
  action: string = '';
  employee_register_form: FormGroup;
  unions: Union[] = [];
  user_types: UserType[] = [];
  genders: Gender[] = [];
  taluks: Taluk[] = [];
  districts: District[] = [];
  states: State[] = [];
  offices: State[] = [];
  roles: State[] = [];
  image: any = null;

  register_on_process = false;
  color: ThemePalette = 'primary';
  value = 50;
  constructor(private formBuilder: FormBuilder, private employeeService: EmployeeService, private http: HttpService, private global: GlobalService, private sanitizer: DomSanitizer) {
    this.getCvData();
    this.employee_register_form = this.formBuilder.group({
      id: [null],
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      union_id: [null, Validators.compose([Validators.required])],
      gender_id: [null, Validators.compose([Validators.required])],
      street: [null],
      taluk_id: [null, Validators.compose([Validators.required])],
      district_id: [null, Validators.compose([Validators.required])],
      state_id: [1, Validators.compose([Validators.required])],
      pincode: [null, Validators.compose([GlobalValidationService.checkPincode])],
      mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber,Validators.required])],
      alternate_mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber])],
      office: [null, Validators.compose([Validators.required])],
      role: [null, Validators.compose([Validators.required])],
      joining_date: [null, Validators.compose([Validators.required])],
      release_date: [null],
      employee_image: [null],
    })

    if (this.employeeService.get_employee_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.employeeService.get_employee_data);
    }

    this.employeeService.employeeUpdate.subscribe((relation_data) => {
      if (relation_data === null) {
        this.action = 'register';
        this.employee_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(relation_data);
      }
    });

    // this.employeeService.employeeUpdate.subscribe((relation_type) => {
    //   this.setupUpdateForm(relation_type);
    // });

  }

  setupUpdateForm(element) {
    console.log(element)
    this.http.getEmployeeDetails(element).subscribe((data)=> {
      console.log(data);
      this.employee_register_form.controls['id'].setValue(data['id']);
      this.employee_register_form.controls['first_name'].setValue(data['first_name']);
      this.employee_register_form.controls['last_name'].setValue(data['last_name']);
      this.employee_register_form.controls['union_id'].setValue(data['union_id']);
      this.employee_register_form.controls['gender_id'].setValue(data['gender_id']);
      this.employee_register_form.controls['street'].setValue(data['street']);
      this.employee_register_form.controls['taluk_id'].setValue(data['taluk_id']);
      this.employee_register_form.controls['district_id'].setValue(data['district_id']);
      this.employee_register_form.controls['state_id'].setValue(data['state_id']);
      this.employee_register_form.controls['pincode'].setValue(data['pincode']);
      this.employee_register_form.controls['mobile'].setValue(data['mobile']);
      this.employee_register_form.controls['alternate_mobile'].setValue(data['alternate_mobile']);
      this.employee_register_form.controls['office'].setValue(data['office_id']);
      this.employee_register_form.controls['role'].setValue(data['role_id']);
      this.employee_register_form.controls['joining_date'].setValue(data['joining_date']);
      this.employee_register_form.controls['release_date'].setValue(data['release_date']);
      if (data.hasOwnProperty('image')) {
        this.image = this.sanitizer.bypassSecurityTrustResourceUrl( 'data:image/png;base64,' + data['image']);
        console.log(this.sanitizer.bypassSecurityTrustResourceUrl( 'data:image/png;base64,' + data['image']))
      }
    })
  }

  toBase64(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend =  (e) =>  {
      console.log(reader.result);
      this.image = reader.result;
      console.log(this.image);
    };
    console.log(reader.readAsDataURL(file));
  }

  getCvData() {
    this.getDistricts();
    this.getUnion();
    this.getUserTypes();
    this.getGender();
    this.getTaluk();
    this.getState();
    this.getOffice();
    this.getRole();
  }

  getDistricts() {
    this.http.getDistrict().subscribe((data: District[]) => {
      console.log(data);
      this.districts = data;
    }, (error) => {
      console.log(error);
    });
  }

  getUnion() {
    this.http.getUnions().subscribe((data: Union[]) => {
      console.log(data);
      this.unions = data;
    }, (error) => {
      console.log(error);
    });
  }

  getUserTypes() {
    this.http.getUserTypes().subscribe((data: UserType[]) => {
      console.log(data);
      this.user_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  getGender() {
    this.http.getGenders().subscribe((data: Union[]) => {
      console.log(data);
      this.genders = data;
    }, (error) => {
      console.log(error);
    });
  }

  getTaluk() {
    this.http.getTaluks().subscribe((data: Taluk[]) => {
      console.log(data);
      this.taluks = data;
    }, (error) => {
      console.log(error);
    });
  }

  getState() {
    this.http.getStates().subscribe((data: State[]) => {
      console.log(data);
      this.states = data;
    }, (error) => {
      console.log(error);
    });
  }

  getOffice() {
    this.http.getOffice().subscribe((data: State[]) => {
      console.log(data);
      this.offices = data;
    }, (error) => {
      console.log(error);
    });
  }

  getRole() {
    this.http.getRole().subscribe((data: State[]) => {
      console.log(data);
      this.roles = data;
    }, (error) => {
      console.log(error);
    });
  }

  registerEmployee() {
    this.register_on_process = true;
    const employee_data = Object.assign({}, this.employee_register_form.value);
    if (this.image != null) {
      employee_data['employee_image'] = this.image;
    }
    console.log(employee_data)
    this.http.registerEmployee(employee_data).subscribe((data) => {
      this.register_on_process = false;
      this.employee_register_form.reset();
      this.employeeService.is_display_employee_register_component = false;
      this.image = null;
      this.global.showSnakeBar(data['message']);
      this.employeeService.downloadEmployee.emit(true);
    }, (error) => {
      this.register_on_process = true;
    });
  }

  ngOnInit() {
  }

}
